import { ContactViewModel } from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { useHistory } from 'react-router';
import { getDefaultDateStringValue, getDefaultTimeStringValue, getUnsubscribeReason } from '../../../../models/UiUtils';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	contact?: ContactViewModel;
	styles?: StyleDeclarationValue[];
}

export const ContactEmailUnsubscribeInfo: React.FC<IProps> = props => {
	const { className, styles, contact } = props;

	const history = useHistory();
	const handleDupContactLinkClick = () => {
		history.push(`/contacts/people/${unsubscribeContact.id}`);
	};
	const unsubscribeDueToDuplicate =
		!contact.unsubscribeMetadata?.date && contact.duplicateContacts?.some(dup => dup.unsubscribeMetadata?.date);
	const unsubscribeContact = unsubscribeDueToDuplicate
		? contact.duplicateContacts.find(dup => dup.unsubscribeMetadata?.date)
		: contact;
	const unsubscribeDate = unsubscribeContact.unsubscribeMetadata?.date;
	const unsubscribeReason = getUnsubscribeReason(unsubscribeContact.unsubscribeMetadata);
	return (
		<div className={`${css(styleSheet.container, ...(styles || []))} component-class ${className || ''}`}>
			{unsubscribeDate && (
				<div>
					{`Contact unsubscribed `}
					{unsubscribeDueToDuplicate ? (
						<>
							due to{' '}
							{unsubscribeContact && (
								<a href={`#/contacts/people/${unsubscribeContact.id}`} onClick={handleDupContactLinkClick}>
									duplicate contact
								</a>
							)}{' '}
							being unsubscribed{' '}
						</>
					) : (
						<>
							{unsubscribeReason && `${unsubscribeReason} `}
							on {getDefaultDateStringValue(unsubscribeDate)} at {getDefaultTimeStringValue(unsubscribeDate)}
						</>
					)}
				</div>
			)}
		</div>
	);
};
